module.exports = __webpack_public_path__ + "media/assets/images/logos/disenia_logo-baca0cff6a3dfcd6824c9be76b81f284.jpg";